// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"styles_cardWrapper__2sjv_","divider":"styles_divider__CBroE","feedbackQuestions":"styles_feedbackQuestions__2RFjs"};